export const TICKET_IMAGE_NAME_CHECK_DELAY = 1000;
